import {Alert, Button, Stack} from "@mui/material";
import {useState} from "react";
import {ErrorDetailContainer} from "../../../api/config";
import {PaymentService} from "../../../api/psc";
import {DialogContainer, DialogHeader} from "../../../components/exports";
import ErrorParser from "../../../components/shared/ErrorParser";
import {createAndSubmitForm} from "../../../utils/FormBuilder";

export default function PurchaseDialog(props: { packageId: number, hasRequestedInvoice: boolean }) {
    const [error, setError] = useState<ErrorDetailContainer | null>(null);
    const [requestInProgress, setRequestInProgress] = useState(false);
    const purchaseNovin = () => {
        setRequestInProgress(true);
        PaymentService.initNovinPayment("1", props.packageId, {hasRequestedInvoice: props.hasRequestedInvoice})
            .then((r) => {
                createAndSubmitForm(r.token, r.ipgwUrl);
            })
            .catch((e) => {
                setError(e);
            })
            .finally(() => {
                setRequestInProgress(false);
            });
    };

    const purchaseSayan = () => {
        setRequestInProgress(true);
        PaymentService.initSayanPayment("1", props.packageId, {hasRequestedInvoice: props.hasRequestedInvoice})
            .then((r) => {
                createAndSubmitForm(r.token, r.ipgwUrl);
            })
            .catch((e) => {
                setError(e);
            })
            .finally(() => {
                setRequestInProgress(false);
            });
    };


    return (
        <DialogContainer>

            <DialogHeader title="انتخاب درگاه پرداخت"/>

            <Stack spacing={2} sx={{p: 2}}>

                <Button
                    variant="contained"
                    color="primary"
                    onClick={purchaseNovin}
                    disabled={requestInProgress}>
                    درگاه بانک رفاه
                </Button>

                <Button
                    variant="contained"
                    color="secondary"
                    onClick={purchaseSayan}
                    disabled={requestInProgress}>
                    درگاه بانک سپه
                </Button>

                <ErrorParser error={error}/>

            </Stack>

        </DialogContainer>
    );
}
